import { AuthStatus, useAuth } from '@montel/montelpro-auth';
import { FullPageLoader } from '@montel/montelpro-shared-components-v2';
import { sideMenuConfig } from 'App/configs';
import GlobalContext from 'components/common/GlobalContext/GlobalContext';
import Header from 'components/common/Header';
import { SideMenu } from 'components/common/Menu';
import { TableViewStateContextProvider } from 'components/tables/TableViewStateContextProvider';
import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from 'styled-components';

const Root: FunctionComponent = () => {
	const { authStatus } = useAuth();

	if (authStatus !== AuthStatus.SUCCESS) {
		return <FullPageLoader />;
	}

	return (
		<>
			<header>
				<Header />
			</header>
			<SideMenu menuConfig={sideMenuConfig} />
			<Wrapper>
				<StyledContainer>
					<GlobalContext>
						<TableViewStateContextProvider>
							<Outlet />
						</TableViewStateContextProvider>
					</GlobalContext>
				</StyledContainer>
			</Wrapper>
		</>
	);
};

const Wrapper = styled.main`
	max-width: 2048px;
	margin: 0 auto;
`;

const StyledContainer = styled.div`
	position: relative;
	margin: 120px 40px 40px 80px;
`;

export default Root;
